module.exports = __webpack_public_path__ + "stormwater/connect/img/porous-pavement.png";